export enum RateDensityEnum {
  DENSITY2 = "<1:2",
  DENSITY3 = "<1:3",
  DENSITY4 = "<1:4",
  DENSITY5 = "<1:5",
  DENSITY6 = "1:6",
}
